/**
 * Repair-Quote flow configuration (Growth Platform — Slice S2).
 *
 * Data-driven options for the guided quote wizard. Kept as config (not JSX)
 * so the flow stays consistent, is easy to extend, and can later be served
 * from the MERN /api without touching the component.
 *
 * `service` values intentionally mirror the labels used in ContactUs.js and
 * the servicesData slugs so downstream reporting stays consistent.
 */

export const DEVICE_TYPES = [
  { value: "iPhone", label: "iPhone", icon: "fab fa-apple" },
  { value: "Samsung", label: "Samsung", icon: "fab fa-android" },
  { value: "iPad", label: "iPad / Tablet", icon: "fas fa-tablet-alt" },
  { value: "MacBook", label: "MacBook", icon: "fas fa-laptop" },
  { value: "Laptop", label: "Windows Laptop", icon: "fas fa-laptop-code" },
  { value: "Desktop", label: "Desktop Computer", icon: "fas fa-desktop" },
  { value: "Other", label: "Other Device", icon: "fas fa-mobile-alt" },
];

/**
 * Common models per device type. Presented as quick-pick chips; the customer
 * can always type an exact model in the free-text field, so this list only
 * needs to cover the most frequent cases — it is not exhaustive.
 */
export const MODELS_BY_DEVICE = {
  iPhone: [
    "iPhone 15 / 15 Pro",
    "iPhone 14 / 14 Pro",
    "iPhone 13 / 13 Pro",
    "iPhone 12 / 12 Pro",
    "iPhone 11 / XR",
    "iPhone SE / Older",
  ],
  Samsung: [
    "Galaxy S24 / S23",
    "Galaxy S22 / S21",
    "Galaxy Note",
    "Galaxy A Series",
    "Galaxy Z Fold / Flip",
    "Other Galaxy",
  ],
  iPad: ["iPad Pro", "iPad Air", "iPad Mini", "Standard iPad", "Other Tablet"],
  MacBook: ["MacBook Air", "MacBook Pro 13\"", "MacBook Pro 14\"/16\"", "Older MacBook"],
  Laptop: ["Dell", "HP", "Lenovo", "ASUS", "Other Brand"],
  Desktop: ["Windows PC", "iMac / Mac", "Custom Build", "Other"],
  Other: ["Smartwatch", "Game Console", "Other Device"],
};

/**
 * Repair issue options. `service` maps to the same service labels used across
 * the site so quote leads are categorized consistently.
 */
export const ISSUE_TYPES = [
  { service: "Screen Repair", label: "Cracked / Broken Screen", icon: "fas fa-mobile-alt" },
  { service: "Battery Replacement", label: "Battery / Won't Hold Charge", icon: "fas fa-battery-quarter" },
  { service: "Charging Port Repair", label: "Won't Charge / Charging Port", icon: "fas fa-plug" },
  { service: "Water Damage", label: "Water / Liquid Damage", icon: "fas fa-tint" },
  { service: "Data Recovery", label: "Data Recovery", icon: "fas fa-database" },
  { service: "Software Issue", label: "Software / Won't Turn On", icon: "fas fa-cogs" },
  { service: "Camera Repair", label: "Camera Issue", icon: "fas fa-camera" },
  { service: "Other", label: "Something Else", icon: "fas fa-question-circle" },
];
